import { render, staticRenderFns } from "./CommunityPostFilters.vue?vue&type=template&id=671cd4ee"
import script from "./CommunityPostFilters.vue?vue&type=script&lang=js"
export * from "./CommunityPostFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports